
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Neuroendocrine_tumors_of_the_colon_and_rectum",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Neuroendocrine_tumors_of_the_colon_and_rectum.vue